export const environment = {
  url: {
    api: `https://apim-dev.houseofhr.com/square-app-accent/api/v2.0`,
  },
  production: false,
  ocpApimSubscriptionKey: '80c5d01c5c3b4981bbffe0a0ed5aac65'
};

